<template>
  <layout>
    <page-header :actions="actions" :header="$t('companies.company_prices')" />
    <div class="content">
      <AdminTable ref="table" v-bind="tableProps">
        <template #company_name="{ item }">
          <router-link
            :to="{ name: 'companies.edit', params: { id: item.company_id } }"
          >
            {{ item.company_name }}
          </router-link>
        </template>
        <template #airport_name="{ item }">
          <router-link
            :to="{ name: 'airports.edit', params: { id: item.airport_id } }"
          >
            {{ item.airport_name }}
          </router-link>
        </template>
        <template #vehicle_name="{ item }">
          <router-link
            :to="{ name: 'vehicles.edit', params: { id: item.vehicle_id } }"
          >
            {{ item.vehicle_name }}
          </router-link>
        </template>
      </AdminTable>
    </div>
  </layout>
</template>

<script>
import { mapState } from 'vuex'
import AdminTable from '../components/AdminTable.vue'
import Api from './TransferPricingApi'

export default {
  name: 'TransferPricingIndex',

  components: {
    AdminTable,
  },

  data() {
    return {
      // Table resource configuration
      tableProps: {
        apiBuilder() {
          return new Api()
        },
        beforeApiRequest(api) {
          api.setParameter('where[division_id]', this.currentDivision?.id)
        },
        columns: [
          {
            key: 'company_name',
            label: this.$t('companies.name'),
          },
          {
            key: 'airport_name',
            label: this.$t('airports.name'),
          },
          {
            key: 'vehicle_name',
            label: this.$t('vehicles.name'),
          },
          {
            key: 'created_at',
            label: this.$t('attributes.created_at'),
            component: 'value-date',
            config: {
              stacked: true,
            },
          },
        ],

        // override search fields here using fields schema
        searchFields: [
          {
            component: 'text-field',
            type: 'search',
            attribute: 'where.query',
            placeholder: 'Search ...',
          },
        ],

        // define custom row actions
        rowActions: (item) => {
          const actions = [
            {
              label: this.$t('general.view'),
              variant: 'light',
              handler: () => {
                this.$router.push({
                  name: 'company-pricings.transfer',
                  params: {
                    company_id: item.company_id,
                    airport_id: item.airport_id,
                    vehicle_id: item.vehicle_id,
                  },
                })
              },
            },
          ]
          return actions
        },

        // define custom bulk actions
        bulkActions() {
          return []
        },
      },
    }
  },

  computed: {
    ...mapState('zones', ['currentDivision']),

    actions() {
      const actions = []
      if (this.$allows('administer')) {
        actions.push({
          id: 'create',
          text: this.$t('general.add_new'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            this.$router.push({
              name: 'company-pricings.transfer',
            })
          },
        })
      }
      return actions
    },
  },

  watch: {
    currentDivision() {
      this.$refs.table.refresh()
    },
  },
}
</script>
